import {
    Modal,
    Tooltip,
    createTheme,
    CSSVariablesResolver,
    Alert,
    virtualColor, MantineColorsTuple,
} from '@mantine/core'

const brandSecondaryColors = [
    '#f8d3cf',
    '#f3b6ad',
    '#ef998b',
    '#eb7c6a',
    '#e85f49',
    '#ee6f61', // Base color
    '#cb594e',
    '#a8463d',
    '#86332c',
    '#64201b',
] as MantineColorsTuple

export const theme = createTheme({
    other: {
        navbarWidth: 280,
        headerHeight: 60,
    },
    autoContrast: true,
    colors: {
        'brand-primary': [
            '#ebf3ff',
            '#dbe3f6',
            '#b7c3e4',
            '#90a3d3',
            '#7086c5',
            '#5a75bd', // Base color
            '#4f6cb9',
            '#3f5ba4',
            '#365193',
            '#294684',
        ],
        'brand-secondary': brandSecondaryColors,

        // Support virtual colors which follow the color schema
        'brand-secondary-reverse': [...brandSecondaryColors].reverse() as unknown as MantineColorsTuple,
        'brand-secondary-virtual': virtualColor({
            name: 'brand-secondary-virtual',
            light: 'brand-secondary',
            dark: 'brand-secondary-reverse',
        }),
    },
    primaryColor: 'brand-primary',
    primaryShade: 5,
    components: {
        Modal: Modal.extend({
            defaultProps: {
                padding: 'lg',
            },
            styles: {
                title: {
                    fontWeight: 'bold',
                },
            },
        }),
        Tooltip: Tooltip.extend({
            defaultProps: {
                withArrow: true,
                openDelay: 50,
                transitionProps: { duration: 200, transition: 'pop' },
            },
            styles: (theme) => ({
                tooltip: {
                    fontSize: theme.fontSizes.xs,
                },
            }),
        }),
        Alert: Alert.extend({
            styles: {
                root: {
                    border: `1px solid var(--alert-bg)`,
                },
                wrapper: {
                    alignItems: 'center',
                },
            },
        }),
    },
})

export const cssVariablesResolver: CSSVariablesResolver = (theme) => ({
    variables: {},
    light: {
        '--mantine-color-background': theme.colors.gray[0],
    },
    dark: {
        '--mantine-color-background': theme.colors.gray[8],
    },
})
